import { Icon } from "@iconify/react/dist/iconify.js";
import { useGoogleLogin } from "@react-oauth/google";

import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Modal, Button, Form, ListGroup } from "react-bootstrap";
import { AiOutlineCheckCircle, AiOutlinePlus } from "react-icons/ai";
import reviewHeroImg from ".././Assets/reviewHeroImg.svg";
import closeimg from "../Assets/closeimg.svg";
import "../components/CSS/SetupReview.css";
import { RefreshCwOff } from "lucide-react";
import MasterLayout from "../masterLayout/MasterLayout";
import { retrieveData } from "../LocalConnection/LocalConnection";
import axios from "axios";
import { handleError, handleSuccess } from "../CommonJquery/CommonJquery";
import { useLocation } from "react-router-dom";
import {
  facebooklogin,
  get_all_reviews_link,
  getLocationID,
  GOOGLE_CLIENT_ID,
  GOOGLE_CLIENT_SECRET,
  GOOGLE_REDIRECTION_URL,
  save_reviews_link_manually,
  server_post_data,
  deactivatePlatformFlag,
  searchTripadvisorLocation,
  REACT_APP_FACEBOOK_APP_ID,
} from "../ServiceConnection/serviceconnection";
import Loader from "./Loader";

let accessToken = null;
let refreshToken = null;
let accountId = null;

/* ---------- helpers (module scope: created once, not per render) ---------- */

const notEmpty = (v) => v !== null && v !== undefined && v !== "";

// A platform is "connected" via API (accesstoken) or via manual link.
const isConnected = (item) =>
  parseInt(item.api_or_link) === 1
    ? notEmpty(item.accesstoken)
    : notEmpty(item.review_link);

/**
 * Backend hamesha "0~@~{json}" bhejta hai — success aur error dono me.
 * Isliye error detection payload ke `error` flag se hoti hai, prefix se nahi.
 */
const parseResponse = (Response) => {
  const parts = String(Response?.message || "").split("~@~");
  try {
    return JSON.parse(parts[1] || "{}");
  } catch {
    return { error: true, message: "Unexpected response from server" };
  }
};

// Exchange a Google auth code for tokens (shared by GMB + Play Store logins).
const exchangeGoogleCode = async (code) => {
  const { data } = await axios.post(
    "https://oauth2.googleapis.com/token",
    null,
    {
      params: {
        code,
        client_id: GOOGLE_CLIENT_ID,
        client_secret: GOOGLE_CLIENT_SECRET,
        redirect_uri: GOOGLE_REDIRECTION_URL,
        grant_type: "authorization_code",
      },
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    },
  );
  return data;
};

function SetupChannels() {
  const [error, setError] = useState(null);
  const [ShowLoaderAdmin, setShowLoaderAdmin] = useState(false);
  const [ReviewLInk, setReviewLInk] = useState("");
  const [packName, setPackName] = useState("");
  const [playAccess, setplayAccess] = useState("");
  const [playRefresh, setplayRefresh] = useState("");
  const [ReviewData, setReviewData] = useState([]);
  const [SelectedReviewData, setSelectedReviewData] = useState([]);
  const [LocatrionList, setLocatrionList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showPlayModal, setShowPlayModal] = useState(false);
  const [showModalLink, setShowModalLink] = useState(false);
  const [showModalRemove, setShowModalRemove] = useState(false);
  const [reconnectStat, setReconnect] = useState(false);
  const [selectedHotel, setSelectedHotel] = useState(null); // stores location "name" (unique id)
  const [ReviewLinkPost, setReviewLinkPost] = useState("");
  const [reconGoogle, setreconnectGoogle] = useState(null);
  const [plan, setplan] = useState("");
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [selected, setSelected] = useState(null);
  const [showModalTrip, setShowModalTrip] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [searching, setSearching] = useState(false);
  const [locationSearchQuery, setLocationSearchQuery] = useState("");

  // Facebook page picker
  const [showFbPageModal, setShowFbPageModal] = useState(false);
  const [fbPages, setFbPages] = useState([]);
  const [fbUserToken, setFbUserToken] = useState("");

  const location = useLocation();
  const bottomRef = useRef(null);

  /* ---------- shared form-data builder ---------- */
  const buildReviewFormData = useCallback(
    (extra = {}) => {
      const fd = new FormData();
      fd.append("rll_id", SelectedReviewData.rll_id);
      fd.append("review_name", SelectedReviewData.review_name);
      fd.append("review_website", SelectedReviewData.review_website);
      fd.append("review_logo", SelectedReviewData.review_logo);
      Object.entries(extra).forEach(([k, v]) => fd.append(k, v ?? ""));
      return fd;
    },
    [SelectedReviewData],
  );

  /* ---------- data loading ---------- */

  const master_data_get = useCallback(async () => {
    setShowLoaderAdmin(true);
    try {
      const Response = await server_post_data(get_all_reviews_link, null);
      const final_data = parseResponse(Response);

      if (final_data.error) {
        handleError(final_data.message);
      } else {
        setReviewLInk(final_data.review_linkss_link);
        setReviewData((final_data.review_linkss_data || []).slice().reverse());
      }
    } catch {
      handleError("network");
    }
    setShowLoaderAdmin(false);
  }, []);

  const master_data_get_google = useCallback(async (token) => {
    setShowLoaderAdmin(true);
    try {
      const formdata = new FormData();
      formdata.append("accessToken", token);
      // accountId jaan boojh ke nahi bhej rahe — backend "accounts/-" use karta
      // hai, jisse group-managed (indirectly owned) locations bhi aati hain.
      // Specific account ID bhejne par sirf directly-owned locations milti hain.

      const Response = await server_post_data(getLocationID, formdata);
      const final_data = parseResponse(Response);

      if (final_data.error) {
        handleError(final_data.message);
      } else {
        // raw_locations me metadata (placeId / newReviewUri) hota hai,
        // jo save karte waqt chahiye
        const locs = final_data.locations || [];
        setLocatrionList(locs);
        setSelectedHotel(locs.length ? locs[0].name : null);
        setLocationSearchQuery("");
        setShowModal(true);
      }
    } catch {
      handleError("network");
    }
    setShowLoaderAdmin(false);
  }, []);

  const fetchAccountAndLocationIds = useCallback(
    async (token) => {
      try {
        const accountResponse = await axios.get(
          "https://mybusinessaccountmanagement.googleapis.com/v1/accounts",
          { headers: { Authorization: `Bearer ${token}` } },
        );
        const accounts = accountResponse.data.accounts;
        if (!accounts || accounts.length === 0) {
          setError("No accounts found");
          handleError("No Google Business accounts found");
          return;
        }
        // accountId save karte waqt chahiye, par locations fetch me nahi
        accountId = accounts[0].name.split("/")[1];
        master_data_get_google(token);
      } catch (err) {
        setError(err.response?.data?.error?.message || "An error occurred");
        handleError(
          err.response?.data?.error?.message || "Could not reach Google",
        );
      }
    },
    [master_data_get_google],
  );

  /* ---------- save / connect actions ---------- */

  const submitGoogleLocation = useCallback(
    async (loca_id, url_for_place, placeId) => {
      setShowLoaderAdmin(true);
      try {
        const formdata = buildReviewFormData({
          accesstoken: accessToken,
          accountid: accountId,
          refreshtoken: refreshToken,
          locationid: loca_id,
          review_link: url_for_place,
          placeid: placeId,
        });
        const Response = await server_post_data(
          save_reviews_link_manually,
          formdata,
        );
        const final_data = parseResponse(Response);

        if (final_data.error) {
          handleError(final_data.message);
        } else {
          const imported = final_data.sync?.inserted;
          handleSuccess(
            imported
              ? `${final_data.message} — ${imported} reviews imported.`
              : final_data.message,
          );
          setShowModal(false);
          setReconnect(false);
          setreconnectGoogle(null);
          master_data_get();
        }
      } catch {
        handleError("network");
      }
      setShowLoaderAdmin(false);
    },
    [buildReviewFormData, master_data_get],
  );

  const save_Link_url_manually = useCallback(async () => {
    if (!ReviewLinkPost || ReviewLinkPost.length <= 15) {
      handleError("Please enter a valid link");
      return;
    }
    setShowLoaderAdmin(true);
    try {
      const formdata = buildReviewFormData({
        review_link: ReviewLinkPost,
        locationid: selected?.locationId ?? "",
      });
      const Response = await server_post_data(
        save_reviews_link_manually,
        formdata,
      );
      const final_data = parseResponse(Response);

      if (final_data.error) {
        handleError(final_data.message);
      } else {
        handleSuccess(final_data.message);
        setShowModalLink(false);
        setShowModalTrip(false);
        master_data_get();
      }
    } catch {
      handleError("network");
    }
    setShowLoaderAdmin(false);
  }, [ReviewLinkPost, selected, buildReviewFormData, master_data_get]);

  const submitplay = useCallback(async () => {
    if (!playAccess || !playRefresh || !packName) {
      handleError("Please enter package name");
      return;
    }
    setShowLoaderAdmin(true);
    try {
      const formdata = buildReviewFormData({
        accesstoken: playAccess,
        accountid: "",
        refreshtoken: playRefresh,
        locationid: packName,
        review_link:
          "https://play.google.com/store/apps/details?id=" + packName,
        placeid: "",
      });
      const Response = await server_post_data(
        save_reviews_link_manually,
        formdata,
      );
      const final_data = parseResponse(Response);

      if (final_data.error) {
        handleError(final_data.message);
      } else {
        handleSuccess(final_data.message);
        setShowPlayModal(false);
        master_data_get();
      }
    } catch {
      handleError("network");
    }
    setShowLoaderAdmin(false);
  }, [playAccess, playRefresh, packName, buildReviewFormData, master_data_get]);

  /* ---------- facebook ---------- */

  const facebookLoginApi = useCallback(
    async (userToken, name, pageId) => {
      setShowLoaderAdmin(true);
      try {
        const formdata = new FormData();
        formdata.append("useraccessToken", userToken);
        if (name) formdata.append("pageName", name);
        if (pageId) formdata.append("pageId", pageId);

        const Response = await server_post_data(facebooklogin, formdata);
        const final_data = parseResponse(Response);

        if (final_data.error) {
          handleError(final_data.message);
          setShowLoaderAdmin(false);
          return;
        }

        // Page choose nahi kiya — backend ne list bheji hai
        if (final_data.needs_page_selection) {
          setFbUserToken(final_data.longLivedUserToken);
          setFbPages(final_data.pages || []);
          setShowFbPageModal(true);
          setShowLoaderAdmin(false);
          return;
        }

        handleSuccess(final_data.message);
        setShowFbPageModal(false);
        master_data_get();
      } catch {
        handleError("network");
      }
      setShowLoaderAdmin(false);
    },
    [master_data_get],
  );

  const loginWithFacebook = useCallback(() => {
    window.FB.login(
      (response) => {
        if (!response.authResponse) {
          handleError("Facebook login was cancelled");
          return;
        }
        // Pages backend khud fetch karta hai (long-lived token ke saath),
        // isliye yahan /me/accounts call ki zarurat nahi.
        facebookLoginApi(response.authResponse.accessToken, "", "");
      },
      {
        scope:
          "public_profile,email,pages_read_engagement,pages_manage_metadata,pages_read_user_content,pages_manage_engagement",
      },
    );
  }, [facebookLoginApi]);

  const initializeAndLoginWithFacebook = useCallback(() => {
    if (window.FB) {
      loginWithFacebook();
      return;
    }
    (function (d, s, id) {
      const fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      const js = d.createElement(s);
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
      js.onload = () => {
        window.FB.init({
          appId: REACT_APP_FACEBOOK_APP_ID,
          cookie: true,
          xfbml: true,
          version: "v21.0",
        });
        loginWithFacebook();
      };
    })(document, "script", "facebook-jssdk");
  }, [loginWithFacebook]);

  const selectFacebookPage = useCallback(
    (page) => {
      facebookLoginApi(fbUserToken, page.name, page.pageId);
    },
    [fbUserToken, facebookLoginApi],
  );

  /* ---------- disconnect ---------- */

  const deactivatePlatform = useCallback(
    async (review_name, rll_id) => {
      setShowLoaderAdmin(true);
      try {
        const formdata = new FormData();
        formdata.append("review_name", review_name);
        formdata.append("rll_id", rll_id);
        const Response = await server_post_data(
          deactivatePlatformFlag,
          formdata,
        );
        const final_data = parseResponse(Response);

        if (final_data.error) {
          handleError(final_data.message);
        } else {
          handleSuccess(final_data.message);
          setShowModalRemove(false);
          master_data_get();
        }
      } catch {
        handleError("network");
      }
      setShowLoaderAdmin(false);
    },
    [master_data_get],
  );

  /* ---------- tripadvisor search ---------- */

  const handleSearch = useCallback(async () => {
    if (!query.trim()) return;
    setSearching(true);
    try {
      const fd = new FormData();
      fd.append("searchQuery", query);
      const Response = await server_post_data(searchTripadvisorLocation, fd);
      const final_data = parseResponse(Response);

      if (final_data.error) {
        handleError(final_data.message);
        setResults([]);
      } else {
        // Backend flattened results deta hai — address_obj ab nahi aata
        setResults(final_data.results || []);
      }
    } catch {
      handleError("Search failed. Please try again.");
      setResults([]);
    }
    setSearching(false);
  }, [query]);

  const handleSelect = useCallback((item, index) => {
    setSelected(item);
    setSelectedId(index);
  }, []);

  /* ---------- oauth logins ---------- */

  const login = useGoogleLogin({
    onSuccess: async (codeResponse) => {
      try {
        const data = await exchangeGoogleCode(codeResponse.code);
        accessToken = data.access_token;

        // Google only sends a refresh_token on the first consent for a client.
        // If this account was connected before it comes back empty — storing
        // that would break the connection an hour later, when the access token
        // expires and there is nothing to refresh with.
        if (data.refresh_token) {
          refreshToken = data.refresh_token;
        }

        fetchAccountAndLocationIds(data.access_token);
      } catch (err) {
        handleError(
          err.response?.data?.error_description ||
            "Google authorization failed",
        );
      }
    },
    flow: "auth-code",
    scope: "https://www.googleapis.com/auth/business.manage",
  });

  const Playlogin = useGoogleLogin({
    onSuccess: async (codeResponse) => {
      try {
        const data = await exchangeGoogleCode(codeResponse.code);
        accessToken = data.access_token;
        if (data.refresh_token) {
          refreshToken = data.refresh_token;
        }
        setplayAccess(data.access_token);
        setplayRefresh(data.refresh_token || "");
        setPackName("");
        setShowPlayModal(true);
      } catch (err) {
        handleError(
          err.response?.data?.error_description ||
            "Google authorization failed",
        );
      }
    },
    flow: "auth-code",
    scope: "https://www.googleapis.com/auth/androidpublisher",
  });

  const handleclicklogin = useCallback(
    (item, Reconnect) => {
      if (Reconnect === 1 || Reconnect === "reconnect") setReconnect(true);
      setSelectedReviewData(item);
      setReviewLinkPost(item.review_link);
      const name = item.review_name.trim();
      if (name === "Google") login();
      else if (name === "Android Play Store") Playlogin();
      else if (name === "Facebook") initializeAndLoginWithFacebook();
    },
    [login, Playlogin, initializeAndLoginWithFacebook],
  );

  /* ---------- modal open/close ---------- */

  const closeLocationModal = useCallback(() => {
    setShowModal(false);
    setLocationSearchQuery("");
  }, []);

  const handleShowModalLink = useCallback((item) => {
    if (item) {
      setSelectedReviewData(item);
      setReviewLinkPost(item.review_link);
    }
    setShowModalLink((p) => !p);
  }, []);

  const handleShowModalLinkTripadvisor = useCallback((item) => {
    setSelectedReviewData(item);
    setReviewLinkPost(item.review_link);
    setQuery("");
    setResults([]);
    setSelected(null);
    setSelectedId(null);
    setShowModalTrip(true);
  }, []);

  const closeTripModal = useCallback(() => {
    setShowModalTrip(false);
    setQuery("");
    setResults([]);
    setSelected(null);
    setSelectedId(null);
  }, []);

  const openDisconnectModal = useCallback((item) => {
    setSelectedReviewData(item);
    setShowModalRemove(true);
  }, []);

  const handleRadioChange = useCallback(
    (hotelName) => setSelectedHotel(hotelName),
    [],
  );
  const handleLocationChange = useCallback(
    (e) => setReviewLinkPost(e.target.value),
    [],
  );

  const savelocationID = useCallback(() => {
    const chosenHotel = LocatrionList.find((h) => h.name === selectedHotel);
    if (!chosenHotel) return;
    submitGoogleLocation(
      chosenHotel.name,
      chosenHotel.metadata?.newReviewUri,
      chosenHotel.metadata?.placeId,
    );
  }, [LocatrionList, selectedHotel, submitGoogleLocation]);

  /* ---------- derived values (memoized) ---------- */

  const filteredLocationList = useMemo(() => {
    const q = locationSearchQuery.trim().toLowerCase();
    if (!q) return LocatrionList;
    return LocatrionList.filter((hotel) => {
      const idPart = hotel.name?.split("/")[1] || "";
      return hotel.title?.toLowerCase().includes(q) || idPart.includes(q);
    });
  }, [LocatrionList, locationSearchQuery]);

  const isLimitReached = useMemo(() => {
    const count = ReviewData.filter((item) => item.review_link !== null).length;
    return (
      (plan === "Basic" && count >= 3) || (plan === "Premium" && count >= 10)
    );
  }, [ReviewData, plan]);

  /* ---------- effects ---------- */

  useEffect(() => {
    if (location.state?.googleReconnect && bottomRef.current) {
      setreconnectGoogle(location.state?.googleReconnect);
      const t = setTimeout(() => {
        bottomRef.current?.scrollIntoView({ behavior: "smooth" });
      }, 300);
      return () => clearTimeout(t);
    }
  }, [location]);

  useEffect(() => {
    master_data_get();
    const package_amt = parseInt(retrieveData("price_amount_package"));
    setplan(package_amt < 1000 ? "Basic" : "Premium");
  }, [master_data_get]);

  return (
    <>
      {ShowLoaderAdmin && <Loader />}
      <MasterLayout>
        <div className="recviewSection setupReviewHeight">
          <div className="revieeHeroimg">
            <img
              src={reviewHeroImg}
              alt="reviewHeroImg"
              title="reviewHeroImg"
            ></img>
          </div>

          <div className="revieHead">
            <div className="d-flex flex-column align-items-center ">
              {" "}
              <h1>Now, integrate your review platforms</h1>
              <p>
                Bring in your reviews from various platforms and begin managing
                them from one central dashboard
              </p>
            </div>
          </div>

          <div className="reviewdata" ref={bottomRef}>
            <div className="row">
              {ReviewData.map((item, index) => {
                const isApi = parseInt(item.api_or_link) === 1;
                const connected = isConnected(item);
                const blocked = isLimitReached && !connected;
                const hasToken = notEmpty(item.accesstoken);
                const showGoogleReconnect =
                  item.review_name === "Google" && reconGoogle;

                return (
                  <div
                    key={index}
                    className="col-md-3 col-sm-4 col-6 widthClass"
                  >
                    <div
                      className="socialdata position-relative"
                      style={{
                        border: connected
                          ? "1px solid var(--success-600)"
                          : "none",
                        backgroundColor: connected ? "#e6f9ec" : "transparent",
                        transition: "all 0.3s ease-in-out",
                        opacity: blocked ? 0.6 : 1,
                        cursor: blocked ? "not-allowed" : "pointer",
                      }}
                    >
                      {hasToken && (
                        <button
                          className="has-indicator w-40-px h-40-px rounded-circle d-flex justify-content-center align-items-center"
                          style={{
                            position: "absolute",
                            top: "-5px",
                            right: "10px",
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                          type="button"
                          data-toggle="tooltip"
                          data-placement="bottom"
                          title="Reconnect"
                          onClick={() => handleclicklogin(item, 1)}
                        >
                          <Icon
                            icon="mdi:sync"
                            className="text-primary-light text-xl"
                          />
                        </button>
                      )}

                      <div className="d-flex flex-column align-items-center justify-content-center cursor-pointer">
                        <img
                          src={ReviewLInk + item.review_logo}
                          alt={item.review_name}
                          title={item.review_name}
                        />
                        <label>{item.review_name}</label>
                      </div>

                      {isApi ? (
                        <>
                          <button
                            type="button"
                            onClick={
                              isLimitReached && !hasToken
                                ? undefined
                                : showGoogleReconnect
                                  ? () => handleclicklogin(item, "reconnect")
                                  : !hasToken
                                    ? () => handleclicklogin(item, "")
                                    : undefined
                            }
                            disabled={isLimitReached && !hasToken}
                            style={{
                              opacity: isLimitReached && !hasToken ? 0.6 : 1,
                              cursor:
                                isLimitReached && !hasToken
                                  ? "not-allowed"
                                  : "pointer",
                            }}
                          >
                            {showGoogleReconnect ? (
                              <AiOutlinePlus
                                style={{ color: "orange", fontSize: "20px" }}
                              />
                            ) : hasToken ? (
                              <AiOutlineCheckCircle
                                style={{ color: "white", fontSize: "20px" }}
                              />
                            ) : (
                              <AiOutlinePlus
                                style={{ color: "white", fontSize: "20px" }}
                              />
                            )}
                            <p>
                              {showGoogleReconnect
                                ? "Reconnect"
                                : hasToken
                                  ? "Connected"
                                  : "Connect"}
                            </p>
                          </button>
                          {hasToken && (
                            <button
                              type="button"
                              onClick={() => openDisconnectModal(item)}
                              className="NewRemoveButton"
                            >
                              <p>Disconnect</p>
                            </button>
                          )}
                        </>
                      ) : (
                        <>
                          <button
                            type="button"
                            style={{
                              backgroundColor: "var(--negative-600)",
                              opacity:
                                isLimitReached && item.review_link === null
                                  ? 0.6
                                  : 1,
                              cursor:
                                isLimitReached && item.review_link === null
                                  ? "not-allowed"
                                  : "pointer",
                            }}
                            disabled={
                              isLimitReached && item.review_link === null
                            }
                            onClick={() =>
                              item.review_name === "Tripadvisor"
                                ? handleShowModalLinkTripadvisor(item)
                                : handleShowModalLink(item)
                            }
                          >
                            {item.review_link != null ? (
                              <AiOutlineCheckCircle
                                style={{ color: "white", fontSize: "20px" }}
                              />
                            ) : (
                              <AiOutlinePlus
                                style={{ color: "white", fontSize: "20px" }}
                              />
                            )}
                            <p>
                              {item.review_link === null
                                ? "Connect"
                                : "Connected"}
                            </p>
                          </button>
                          {item.review_link != null && (
                            <button
                              type="button"
                              onClick={() => openDisconnectModal(item)}
                              className="NewRemoveButton"
                            >
                              <p>Disconnect</p>
                            </button>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/**-----------location Card Modal--------------- */}
        <Modal
          className="LocationCardModalSetup"
          show={showModal}
          onHide={closeLocationModal}
          centered
          backdrop="static"
        >
          <Modal.Body className="modal_body">
            <div
              className="closeInvoiceSubs closeInvoiceSubsetupPage"
              onClick={closeLocationModal}
            >
              <img src={closeimg} alt="close"></img>
            </div>

            <div className="ManageLocationHeading mb-16">
              <h6>Manage Location</h6>
            </div>

            <div className="locationSearchBox mb-3">
              <Icon icon="mdi:magnify" className="locationSearchIcon" />
              <input
                type="text"
                placeholder="Search location by name or ID"
                value={locationSearchQuery}
                onChange={(e) => setLocationSearchQuery(e.target.value)}
              />
            </div>

            <div className="locationListScroll">
              {filteredLocationList.length > 0 ? (
                filteredLocationList.map((hotel, index) => (
                  <div
                    key={hotel.name || index}
                    className={`locationCardShowDiv ${
                      selectedHotel === hotel.name ? "selected" : ""
                    }`}
                    style={{
                      outline:
                        selectedHotel === hotel.name
                          ? "1px solid var(--primary-600)"
                          : "none",
                    }}
                    onClick={() => handleRadioChange(hotel.name)}
                  >
                    <div className="d-flex flex-column align-items-start">
                      <p style={{ fontSize: "16px" }}>{hotel.title}</p>
                      <p style={{ fontSize: "14px" }}>
                        {hotel.storefrontAddress?.locality ||
                          hotel.name?.split("/")[1]}
                      </p>
                    </div>
                    <div className="SelectHotlRedio">
                      <input
                        type="radio"
                        className="redRadio"
                        name="hotelSelection"
                        checked={selectedHotel === hotel.name}
                        onChange={() => handleRadioChange(hotel.name)}
                      />
                    </div>
                  </div>
                ))
              ) : (
                <p className="text-muted mb-0 text-center py-3">
                  No locations match your search
                </p>
              )}
            </div>

            <div className="SaveCancelLocation">
              <button type="button" onClick={closeLocationModal}>
                Cancel
              </button>
              <button
                type="button"
                className="SavebttnLocatio"
                disabled={!selectedHotel}
                onClick={savelocationID}
              >
                Save
              </button>
            </div>
          </Modal.Body>
        </Modal>

        {/* Facebook Page Picker Modal */}
        <Modal
          className="LocationCardModalSetup"
          show={showFbPageModal}
          onHide={() => setShowFbPageModal(false)}
          centered
          backdrop="static"
        >
          <Modal.Body className="modal_body">
            <div
              className="closeInvoiceSubs closeInvoiceSubsetupPage"
              onClick={() => setShowFbPageModal(false)}
            >
              <img src={closeimg} alt="close"></img>
            </div>

            <div className="ManageLocationHeading mb-16">
              <h6>Select Facebook Page</h6>
            </div>

            <div className="locationListScroll">
              {fbPages.length > 0 ? (
                fbPages.map((page) => (
                  <div
                    key={page.pageId}
                    className="locationCardShowDiv"
                    onClick={() => selectFacebookPage(page)}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="d-flex align-items-center gap-2">
                      {page.picture && (
                        <img
                          src={page.picture}
                          alt={page.name}
                          style={{
                            width: 36,
                            height: 36,
                            borderRadius: "50%",
                          }}
                        />
                      )}
                      <div className="d-flex flex-column align-items-start">
                        <p style={{ fontSize: "16px", marginBottom: 0 }}>
                          {page.name}
                        </p>
                        <p style={{ fontSize: "14px", marginBottom: 0 }}>
                          {page.category}
                          {page.fanCount ? ` · ${page.fanCount} followers` : ""}
                        </p>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p className="text-muted mb-0 text-center py-3">
                  No pages found on this account
                </p>
              )}
            </div>

            <div className="SaveCancelLocation justify-content-center">
              <button type="button" onClick={() => setShowFbPageModal(false)}>
                Cancel
              </button>
            </div>
          </Modal.Body>
        </Modal>

        <Modal
          className="LocationCardModalSetup"
          show={showPlayModal}
          onHide={() => setShowPlayModal(false)}
          centered
          backdrop="static"
        >
          <Modal.Body className="modal_body">
            <div
              className="closeInvoiceSubs closeInvoiceSubsetupPage"
              onClick={() => setShowPlayModal(false)}
            >
              <img src={closeimg} alt="close"></img>
            </div>
            <div className="ManageLocationHeading mb-16">
              <h6>Enter Package Name</h6>
            </div>

            <div>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Package Name"
                value={packName}
                onChange={(e) => setPackName(e.target.value)}
              />
            </div>
            <div className="SaveCancelLocation">
              <button type="button" onClick={() => setShowPlayModal(false)}>
                Cancel
              </button>
              <button
                type="button"
                className="SavebttnLocatio"
                disabled={!packName}
                onClick={submitplay}
              >
                Submit
              </button>
            </div>
          </Modal.Body>
        </Modal>

        {/* Add Link Modal */}
        <Modal
          className="LocationCardModalSetup"
          show={showModalLink}
          onHide={() => setShowModalLink(false)}
          centered
          backdrop="static"
        >
          <Modal.Body className="modal_body">
            <div
              className="closeInvoiceSubs closeInvoiceSubsetupPage"
              onClick={() => setShowModalLink(false)}
            >
              <img src={closeimg} alt="close"></img>
            </div>

            <div className="ManageLocationHeading mb-16">
              <h6 style={{ marginBottom: "0", paddingBottom: "0" }}>
                Add Link of Your {SelectedReviewData.review_name} Account
              </h6>
            </div>

            <div className="linkInput">
              <label className="mb-2">Link</label>
              <br />
              <input
                type="text"
                placeholder={`Enter or Paste your ${SelectedReviewData.review_name} Link`}
                defaultValue={notEmpty(ReviewLinkPost) ? ReviewLinkPost : ""}
                onChange={handleLocationChange}
                id="review_link"
                name="review_link"
              />
            </div>

            <div className="SaveCancelLocation justify-content-center">
              <button type="button" onClick={() => setShowModalLink(false)}>
                Cancel
              </button>
              <button
                type="button"
                className="SavebttnLocatio"
                onClick={save_Link_url_manually}
              >
                Save
              </button>
            </div>
          </Modal.Body>
        </Modal>

        {/* Disconnect channel Modal */}
        <Modal
          className="LocationCardModalSetup"
          show={showModalRemove}
          onHide={() => setShowModalRemove(false)}
          centered
          backdrop="static"
        >
          <Modal.Body className="modal_body">
            <div
              className="closeInvoiceSubs closeInvoiceSubsetupPage"
              onClick={() => setShowModalRemove(false)}
            >
              <img src={closeimg} alt="close"></img>
            </div>

            <div className="ManageLocationHeading mb-16">
              <div className="ipass-stat-icon red">
                <RefreshCwOff size={24} />
              </div>
              <p style={{ fontWeight: "500", fontSize: "16px" }}>
                Are you sure you want to Disconnect from this platform
              </p>
            </div>

            <div className="SaveCancelLocation justify-content-center">
              <button type="button" onClick={() => setShowModalRemove(false)}>
                Go Back
              </button>
              <button
                type="button"
                className="SavebttnLocatio"
                onClick={() =>
                  deactivatePlatform(
                    SelectedReviewData.review_name,
                    SelectedReviewData.rll_id,
                  )
                }
              >
                Confirm
              </button>
            </div>
          </Modal.Body>
        </Modal>

        {/* Tripadvisor Search Modal */}
        <Modal
          show={showModalTrip}
          onHide={closeTripModal}
          centered
          backdrop="static"
          keyboard={true}
          className="TripSearchModal"
        >
          <Modal.Header closeButton className="border-0 pb-0">
            <Modal.Title style={{ fontSize: "16px", fontWeight: 600 }}>
              Search Location
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="linkInput mb-3">
              <label className="mb-2">Link</label>
              <br />
              <input
                type="text"
                placeholder={`Enter or Paste your ${SelectedReviewData.review_name} Link`}
                defaultValue={notEmpty(ReviewLinkPost) ? ReviewLinkPost : ""}
                onChange={handleLocationChange}
                id="review_link"
                name="review_link"
              />
            </div>

            <div className="d-flex tripSearchRow">
              <Form.Control
                type="text"
                placeholder="Enter Location name"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleSearch();
                  }
                }}
              />
              <Button
                type="button"
                variant="primary"
                className="ms-2"
                onClick={handleSearch}
                disabled={searching || !query.trim()}
              >
                {searching ? "Searching..." : "Search"}
              </Button>
            </div>

            <ListGroup className="tripResultsList mt-3">
              {searching ? (
                <p className="text-muted mb-0">Searching...</p>
              ) : results.length > 0 ? (
                results.map((item, index) => (
                  <div
                    key={item.locationId || index}
                    className={`list-group-item tripResultItem ${
                      selectedId === index ? "activeLiItem" : ""
                    }`}
                    onClick={() => handleSelect(item, index)}
                  >
                    <strong>{item.name}</strong>
                    <br />
                    <small>
                      {[item.address, item.city, item.country]
                        .filter(Boolean)
                        .join(", ")}
                    </small>
                  </div>
                ))
              ) : (
                <p className="text-muted mb-0">No results found</p>
              )}
            </ListGroup>
          </Modal.Body>
          <Modal.Footer className="border-0">
            <Button type="button" variant="secondary" onClick={closeTripModal}>
              Close
            </Button>
            <Button
              type="button"
              variant="primary"
              disabled={!selected}
              onClick={save_Link_url_manually}
            >
              Confirm
            </Button>
          </Modal.Footer>
        </Modal>
      </MasterLayout>
    </>
  );
}

export default SetupChannels;
